import { call, put, takeEvery } from 'redux-saga/effects';
import {
  editPayoutMethodRequest,
  getBalanceRequest,
  getSalesRequest,
  getStatsRequest,
  getTipsterFeeTiers,
} from '../../api/dashboard';
import { dashboardActions } from '../../store/dashboard/actions';

import {
  GET_STATS_REQUEST,
  GET_STATS_FAILURE,
  PUT_PAYOUTS_METHOD_REQUEST,
  PUT_PAYOUTS_METHOD_FAILURE,
  DOWNLOAD_ALL_CSV_REQUEST,
  DOWNLOAD_ALL_CSV_FAILURE,
  GET_SALES_REQUEST,
  GET_SALES_FAILURE,
  GET_BALANCE_REQUEST,
  GET_BALANCE_FAILURE,
  TIPSTER_FEE_TIERS_REQUEST,
  TIPSTER_FEE_TIERS_FAILURE,
  PUT_BALANCE_REQUEST,
  PUT_BALANCE_FAILURE,
} from '../../constants/dashboard';
import { toast } from 'react-toastify';

//Tr
import i18n from '../../i18n';
import {
  prepareSalesCSV,
  prepareBalanceCSV,
} from '../../components/Dashboard/Utils/dashboardUtils';
import {
  BalanceData,
  BalanceDataFromAPI,
  FeeTier,
  FeeTierFromAPI,
  SalesDataFromAPI,
} from './types';

function* TipsterFeeTiersFailureSaga(action: any) {
  yield toast.error(i18n.t('tispter-fee-tiers-get-data_error'));
  // toast.error(action.payload);
}

function* TipsterFeeTiersRequestSaga(action: any): any {
  try {
    const { fee_tiers }: { fee_tiers: FeeTierFromAPI[] } = yield call(
      getTipsterFeeTiers,
      action.payload,
    );

    const tipsterFeeTiers = fee_tiers.map(
      (feeTierFromAPI: FeeTierFromAPI) => new FeeTier(feeTierFromAPI),
    );

    yield put(dashboardActions.tipsterFeeTiersSuccessAction(tipsterFeeTiers));
  } catch (e: any) {
    yield put(dashboardActions.tipsterFeeTiersFailureAction(e));
  }
}

function* SalesFailureSaga(action: any) {
  yield toast.error(i18n.t('sales-get-data_error'));
  // toast.error(action.payload);
}

function* SalesRequestSaga(action: any): any {
  try {
    const { sales_data: sales }: { sales_data: SalesDataFromAPI } = yield call(
      getSalesRequest,
      action.payload,
    );
    if (action.payload.cursor) {
      yield put(dashboardActions.salesNextPageSuccessAction(sales));
    } else {
      yield put(dashboardActions.salesSuccessAction(sales));
    }
  } catch (e: any) {
    yield put(dashboardActions.salesFailureAction(e));
  }
}

function* BalanceFailureSaga(action: any) {
  yield toast.error(i18n.t('payouts-get-data_error'));
  // toast.error(action.payload);
}

function* BalanceRequestSaga(action: any): any {
  try {
    const { balance }: { balance: BalanceDataFromAPI } = yield call(
      getBalanceRequest,
      action.payload,
    );
    if (action.payload.cursor !== undefined) {
      yield put(
        dashboardActions.balanceNextPageSuccessAction(new BalanceData(balance)),
      );
    } else {
      yield put(
        dashboardActions.balanceSuccessAction(new BalanceData(balance)),
      );
    }
  } catch (e: any) {
    yield put(dashboardActions.balanceFailureAction(e));
  }
}

function* StatsRequestSaga(action: any): any {
  try {
    const earnings = yield call(getStatsRequest, action.payload);
    yield put(dashboardActions.statsSuccessAction(earnings));
  } catch (e: any) {
    yield put(dashboardActions.statsFailureAction(e));
  }
}
function* StatsFailureSaga(action: any) {
  yield toast.error(i18n.t('stats-get-data_error'));
  // toast.error(action.payload);
}

function* PayoutMethodRequestSaga(action: any): any {
  try {
    const payout_method = yield call(editPayoutMethodRequest, action.payload);
    yield put(
      dashboardActions.editPayoutMethodSuccessAction({
        payout_method,
      }),
    );
    toast.success(i18n.t('payout_method-put-data_success'));
  } catch (e: any) {
    yield put(dashboardActions.editPayoutMethodFailureAction(e));
  }
}
function* PayoutMethodFailureSaga(action: any) {
  yield toast.error(i18n.t('payout_method-put-data_error'));
}

function* DownloadAllCsvFailureSaga(action: any) {
  yield toast.error(i18n.t(`download-all-csv_error`));
  // toast.error(action.payload);
}

function* DownloadAllCsvRequestSaga(action: any) {
  const result: any[] = [];
  try {
    switch (action.payload.download_type) {
      case 'earnings':
        let salesCursor;
        do {
          action.payload.cursor = salesCursor;
          const {
            sales_data: { sales },
          } = yield call(getSalesRequest, {
            ...action.payload,
            limit: 500,
          });
          sales.length && result.push(...sales);
          salesCursor =
            sales.length === 500 ? sales[sales.length - 1].id : undefined;
        } while (salesCursor !== undefined);

        const parsedSalesResult = prepareSalesCSV(result);
        yield put(
          dashboardActions.downloadAllCsvSuccessAction(parsedSalesResult),
        );
        break;
      case 'payouts':
        let payoutsCursor;
        do {
          action.payload.cursor = payoutsCursor;
          const {
            balance: { transactions: payouts },
          } = yield call(getBalanceRequest, {
            ...action.payload,
            limit: 500,
          }) || [];
          payouts.length && result.push(...payouts);
          payoutsCursor =
            payouts.length === 500 ? payouts[payouts.length - 1].id : undefined;
        } while (payoutsCursor !== undefined);

        const parsedPayoutsResult = prepareBalanceCSV(result);
        yield put(
          dashboardActions.downloadAllCsvSuccessAction(parsedPayoutsResult),
        );
        break;
    }
  } catch (e: any) {
    yield put(dashboardActions.downloadAllCsvFailureAction(e));
  }
}

export function* earningsSaga() {
  yield takeEvery(TIPSTER_FEE_TIERS_REQUEST, TipsterFeeTiersRequestSaga);
  yield takeEvery(TIPSTER_FEE_TIERS_FAILURE, TipsterFeeTiersFailureSaga);
  yield takeEvery(GET_SALES_FAILURE, SalesFailureSaga);
  yield takeEvery(GET_SALES_REQUEST, SalesRequestSaga);
  yield takeEvery(GET_BALANCE_FAILURE, BalanceFailureSaga);
  yield takeEvery(GET_BALANCE_REQUEST, BalanceRequestSaga);
  yield takeEvery(PUT_PAYOUTS_METHOD_REQUEST, PayoutMethodRequestSaga);
  yield takeEvery(PUT_PAYOUTS_METHOD_FAILURE, PayoutMethodFailureSaga);
  yield takeEvery(PUT_BALANCE_REQUEST, PayoutMethodRequestSaga);
  yield takeEvery(PUT_BALANCE_FAILURE, PayoutMethodFailureSaga);
  yield takeEvery(GET_STATS_REQUEST, StatsRequestSaga);
  yield takeEvery(GET_STATS_FAILURE, StatsFailureSaga);
  yield takeEvery(DOWNLOAD_ALL_CSV_FAILURE, DownloadAllCsvFailureSaga);
  yield takeEvery(DOWNLOAD_ALL_CSV_REQUEST, DownloadAllCsvRequestSaga);
}
